import brandActionsCreator from '@/state/slices/brand/actions';
import exposerActionsCreator from '@/state/slices/exposer/actions';
import iconsActionsCreator from '@/state/slices/icons/actions';
import navigationActionsCreator from '@/state/slices/navigation/actions';
import refActionsCreator from '@/state/slices/ref/actions';
import savedBuildsActionsCreator from '@/state/slices/saved-builds/actions';
import secondaryNavActionsCreator from '@/state/slices/secondary-nav/actions';
import { IActions, IStore, SetState } from '@/state/slices/typings';
import windowActionsCreator from '@/state/slices/window/actions';

const actionsCreator = (set: SetState<IStore>, get: () => IStore): IActions => {
	return {
		...brandActionsCreator(set, get),
		...iconsActionsCreator(set, get),
		...windowActionsCreator(set),
		...navigationActionsCreator(set, get),
		...refActionsCreator(set, get),
		...exposerActionsCreator(set, get),
		...savedBuildsActionsCreator(set),
		...secondaryNavActionsCreator(set),
	};
};

export default actionsCreator;
